"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'ContentHeader',
  props: {
    title: {
      type: String,
      default: null
    }
  },
  data: function data() {
    return {};
  },
  mounted: function mounted() {},
  methods: {}
};